import { z } from "zod";
import { VIEWER_ROLES } from "../constants/index";
import { email, isoDate, nonEmpty, uuid } from "./_primitives";
import { httpUrl } from "./url";

export const recipientSchema = z.object({
  name: nonEmpty.max(200),
  email,
  company: z.string().trim().max(200).optional(),
});

export const composeIssuanceSchema = z.object({
  // Compose-selected campaign (board #2511) — drives consent-tier enforcement
  // server-side; falls back to the playlist's campaign when omitted.
  campaignId: uuid.nullable().optional(),
  playlistId: uuid,
  recipients: z.array(recipientSchema).min(1).max(50),
  welcomeMessage: z.string().max(1000).optional(),
  personalIntroVideoId: uuid.nullable().optional(),
  ctaLabel: z.string().max(60).optional(),
  ctaUrl: httpUrl.optional(),
  expiryDate: isoDate, // ISO; server validates > now and ≤ 365d
  ndaRequired: z.boolean().default(false),
  allowForwarding: z.boolean().default(true),
  notifierUserIds: z.array(uuid).max(20).default([]),
  noViewCadenceDays: z.number().int().min(1).max(30).nullable().optional(),
  accountRef: z.string().max(120).optional(),
  dealRef: z.string().max(120).optional(),
  // Audit V1: recipient role hint for role-scoped onboarding playlist
  // suggestion + auto-tags resulting viewer rows.
  recipientRole: z.enum(VIEWER_ROLES).optional(),
  // Audit V1: when true (default), follow-up emails won't include specific
  // viewer stats (% completion, video names). Sender can opt out per-pack.
  suppressAnalyticsInEmail: z.boolean().default(true),
});

export type RecipientInput = z.infer<typeof recipientSchema>;
export type ComposeIssuanceInput = z.infer<typeof composeIssuanceSchema>;
